import { PwcOrderListContainer } from './list/container';
import { PwcOrderViewContainer } from './view/container';

export const PwcOrderListRoute = PwcOrderListContainer;
export const PwcOrderViewRoute = PwcOrderViewContainer;
